module.exports = __webpack_public_path__ + "static/media/content.5b02a984.png";


//////////////////
// WEBPACK FOOTER
// ./src/staticPage/tmsAbout/img/content.png
// module id = 439
// module chunks = 0